module.exports = __webpack_public_path__ + "media/images/area-badges/virtual-connections-314b0086a3a0790e960bef6f06ee2b9a.svg";